import styled from 'styled-components'
import { Paper } from '@material-ui/core'
import { P } from '../StyledText'

export const StyledPaper = styled(Paper)`
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  margin-top: 10px;
  left: 0;
  right: 0;
  top: 70%;
` as React.ComponentType<any>

export const StyledNoOption = styled(P)`
  padding: 12px 8px;
` as React.ComponentType<any>
